import { render, staticRenderFns } from "./SituationsConfig.vue?vue&type=template&id=9d769958&scoped=true"
import script from "./SituationsConfig.vue?vue&type=script&lang=js"
export * from "./SituationsConfig.vue?vue&type=script&lang=js"
import style0 from "./SituationsConfig.vue?vue&type=style&index=0&id=9d769958&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d769958",
  null
  
)

export default component.exports